import ApiBase from './Api'
import { WatchListEntity, WatchListItemType } from '@finance-lab/utils/types'

const BASE_PATH = '/watch-lists'

export class WatchListsApi extends ApiBase {
    async getAll() {
        return this._getRequest<WatchListEntity[]>(BASE_PATH)
    }

    async createItem(type: WatchListItemType, id: string) {
        return this._postRequest(BASE_PATH, { entityType: type, entityId: id })
    }

    async deleteItem(type: WatchListItemType, id: string) {
        return this._deleteRequest(BASE_PATH + '?' + new URLSearchParams({ entityType: type, entityId: id }).toString())
    }
}
